export const openDocument = (documentId) => {
  window.open(process.env.REACT_APP_APP_URL + '/document/' + documentId + '.html', documentId);
}
